import axios from "axios";

const baseUrl = process.env.VUE_APP_MAIL_API_URL;
axios.defaults.baseURL = baseUrl;

const axiosInstance = axios.create({ baseUrl });

axiosInstance.getBaseUrl = () => {
    return baseUrl;
}

const resource = '';

export default {
    sendMail($data) {
        return axiosInstance.post(`${resource}`, $data);
    },
}